import { Controller } from "stimulus";
import hideElement from "../../functions/hideElement";
import showElement from "../../functions/showElement";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";

export default class extends Controller {
  static get targets() {
    return ["select", "hiddenDiv"];
  }

  connect() {
    if (!this.preventInitialCheck) {
      this.checkVisibility();
    }
  }

  checkVisibility() {
    const selectedValues = Array.from(this.selectTarget.selectedOptions, (option) => option.value);

    this.hiddenDivTargets.forEach((target) => {
      const isVisible = this.triggerValues(target).some((value) => selectedValues.includes(value));

      if (isVisible) {
        showElement(target);

        this.hiddenInputs(target).forEach(enableElement);
      } else {
        hideElement(target);

        this.hiddenInputs(target).forEach(disableElement);
      }
    });
  }

  // Each target defines which value triggers it via data-show-on, or which values via
  // data-show-on-any (a JSON array): it is shown while any of them is selected.
  triggerValues(target) {
    if (target.dataset.showOnAny) {
      return JSON.parse(target.dataset.showOnAny);
    }

    return [target.dataset.showOn];
  }

  hiddenInputs(container) {
    return [
      ...container.querySelectorAll("input"),
      ...container.querySelectorAll("select"),
      ...container.querySelectorAll("textarea")
    ];
  }

  get preventInitialCheck() {
    return this.element.dataset.preventInitialCheck === "true";
  }
}
